import Vue from 'vue'
import Router from 'vue-router'

import NotFound from '@/views/NotFound.vue'

import CampaignsList from '@/views/Campaigns/CampaignsList.vue'
import CampaignDetail from '@/views/Campaigns/CampaignDetail.vue'
import CampaignInfo from '@/views/Campaigns/CampaignInfo.vue'
import CampaignVoting from '@/views/Campaigns/CampaignVoting.vue'
import CampaignNews from '@/views/Campaigns/CampaignNews.vue'

import EventsList from '@/views/Events/EventsList.vue'
import EventDetail from '@/views/Events/EventDetail.vue'
import EventSection from '@/views/Events/EventSection.vue'
import EventNews from '@/views/Events/EventNews.vue'
import EventCheckIn from '@/views/Events/EventCheckIn.vue'
import EventVoting from '@/views/Events/EventVoting.vue'

import ElectionsList from '@/views/Elections/ElectionsList.vue'
import ElectionDetail from '@/views/Elections/ElectionDetail.vue'
import ElectionRegistration from '@/views/Elections/ElectionRegistration.vue'
import ElectionSection from '@/views/Elections/ElectionSection.vue'
import ElectionRegistrationConfirm from '@/views/Elections/ElectionRegistrationConfirm.vue'
import ElectionVoting from '@/views/Elections/ElectionVoting.vue'

import NCCampaignsList from '@/components/NationalCouncil/NCCampaignsList.vue'
import NCCampaignDetail from '@/components/NationalCouncil/NCCampaignDetail.vue'
import NCCampaignInvite from '@/components/NationalCouncil/NCCampaignInvite.vue'

import SubmitCampaign from '@/views/Campaigns/SubmitCampaign.vue'

import QuestionnaireList from '@/views/Voting/QuestionnaireList.vue'
import QuestionnaireDetail from '@/views/Voting/QuestionnaireDetail.vue'

import NewsList from '@/views/News/NewsList.vue'
import Article from '@/views/News/Article.vue'
import Registration from '@/views/User/Registration.vue'
import SuccessfulRegistration from '@/views/User/SuccessfulRegistration.vue'
import ForgottenPassword from '@/views/User/ForgottenPassword.vue'
import UpdatePassword from '@/views/User/UpdatePassword.vue'
import Profile from '@/views/User/Profile.vue'
import Login from '@/views/User/Login.vue'
import TokenLogin from '@/views/User/TokenLogin.vue'
import Page from '@/views/Pages/Page.vue'

export function createRouter() {
  Vue.use(Router)

  const router = new Router({
    mode: 'history',
    scrollBehavior() {
      return { x: 0, y: 0 }
    },
    routes: [
      {
        path: '/',
        redirect: '/events',
        meta: { title: 'Заседания' }
      },
      {
        path: '/campaigns',
        alias: encodeURIComponent('/campaigns'),
        name: 'campaigns',
        component: CampaignsList,
        meta: { title: 'Кампании' }
      },
      {
        path: '/campaigns/:slug',
        alias: encodeURIComponent('/campaigns/:slug'),
        name: 'campaign',
        component: CampaignDetail,
        children: [
          {
            path: '',
            alias: encodeURIComponent(''),
            component: CampaignInfo,
            name: 'campaign-info',
            meta: { hero: true, tabs: true, back: 'campaigns' },
          },
          {
            path: 'news',
            alias: encodeURIComponent('news'),
            component: CampaignNews,
            name: 'campaign-news',
            meta: { hero: true, tabs: true, back: 'campaigns' },
          },
          {
            path: 'voting',
            alias: encodeURIComponent('voting'),
            component: CampaignVoting,
            name: 'campaign-voting',
            meta: { hero: true, tabs: true, back: 'campaigns' },
          }
        ]
      },
      {
        path: '/submit-campaign',
        alias: encodeURIComponent('/submit-campaign'),
        component: SubmitCampaign,
        name: 'submit-campaign',
        meta: { title: 'Предложи кампания' }
      },

      {
        path: '/events',
        alias: encodeURIComponent('/events'),
        name: 'events',
        component: EventsList,
        meta: { title: 'Заседания', tabs: true }
      },

      {
        path: '/events/past',
        alias: encodeURIComponent('/events/past'),
        name: 'events-past',
        component: EventsList,
        meta: { title: 'Заседания', tabs: true }
      },

      {
        path: '/events/:slug',
        alias: encodeURIComponent('/events/:slug'),
        name: 'event',
        component: EventDetail,
        meta: { back: 'events', tabs: true, hero: true },
        children: [
          {
            path: 'invite',
            alias: encodeURIComponent('invite'),
            component: EventSection,
            name: 'event-invite',
            meta: { back: 'events', tabs: true, hero: true }
          },
          {
            path: 'agenda',
            alias: encodeURIComponent('agenda'),
            component: EventSection,
            name: 'event-agenda',
            meta: { back: 'events', tabs: true, hero: true }
          },
          {
            path: 'proposals',
            alias: encodeURIComponent('proposals'),
            component: EventSection,
            name: 'event-proposals',
            meta: { back: 'events', tabs: true, hero: true }
          },
          {
            path: 'nominations',
            alias: encodeURIComponent('nominations'),
            component: EventSection,
            name: 'event-nominations',
            meta: { back: 'events', tabs: true, hero: true }
          },
          {
            path: 'voting',
            alias: encodeURIComponent('voting'),
            component: EventVoting,
            name: 'event-voting',
            meta: { back: 'events', tabs: true, hero: true }
          },
          {
            path: 'checkin',
            component: EventCheckIn,
            name: 'checkin',
            meta: { back: 'events', tabs: true, hero: true }
          },
          {
            path: 'news',
            alias: encodeURIComponent('news'),
            component: EventNews,
            name: 'event-news',
            meta: { hero: true, tabs: true, back: 'events' },
          }
        ]
      },

      {
        path: '/elections',
        alias: encodeURIComponent('/elections'),
        name: 'elections',
        component: ElectionsList,
        meta: { title: 'Избори' }
      },

      {
        path: '/elections/:slug',
        alias: encodeURIComponent('/elections/:slug'),
        name: 'election',
        component: ElectionDetail,
        meta: { tabs: true, back: 'elections' },
        children: [
          {
            path: 'registrations/:code?',
            alias: encodeURIComponent('registrations/:code?'),
            component: ElectionRegistration,
            name: 'election-registration',
            meta: { tabs: true, back: 'elections' },
          },
          {
            path: 'registrations/verify/:token',
            alias: encodeURIComponent('registrations/verify/:token'),
            component: ElectionRegistrationConfirm,
            name: 'election-registration-confirm',
            meta: { tabs: true, back: 'elections' },
          },
          {
            path: 'candidates',
            alias: encodeURIComponent('candidates'),
            component: ElectionSection,
            name: 'election-candidates',
            meta: { tabs: true, back: 'elections' },
          },
          {
            path: 'rules',
            alias: encodeURIComponent('rules'),
            component: ElectionSection,
            name: 'election-rules',
            meta: { tabs: true, back: 'elections' },
          },
          {
            path: 'voting',
            alias: encodeURIComponent('voting'),
            component: ElectionVoting,
            name: 'election-voting',
            meta: { requiresAuth: true, tabs: true, back: 'elections' },
          }
        ]
      },

      {
        path: '/national-council',
        alias: encodeURIComponent('/national-council'),
        name: 'national-council',
        component: NCCampaignsList,
        meta: { title: 'Национален съвет' }
      },
      {
        path: '/national-council/:slug',
        alias: encodeURIComponent('/national-council/:slug'),
        name: 'nc-campaign',
        component: NCCampaignDetail,
        meta: { title: 'Национален съвет' },
        children: [
          { path: 'proposals', alias: encodeURIComponent('proposals'), component: CampaignNews, name: 'nc-campaign-news' },
          { path: 'proposals/:articleSlug', alias: encodeURIComponent('proposals/:articleSlug'), component: Article, name: 'nc-campaign-article' },
          { path: 'invite', alias: encodeURIComponent('invite'), component: NCCampaignInvite, name: 'nc-campaign-invite' },
          { path: 'agenda', alias: encodeURIComponent('agenda'), component: CampaignInfo, name: 'nc-campaign-info' },
          { path: 'voting', alias: encodeURIComponent('voting'), component: CampaignVoting, name: 'nc-campaign-voting' }
        ]
      },

      {
        path: '/questionnaires',
        alias: encodeURIComponent('/questionnaires'),
        name: 'questionnaires',
        component: QuestionnaireList,
        meta: { title: 'Анкети' }
      },

      {
        path: '/questionnaires/:id',
        alias: encodeURIComponent('/questionnaires/:id'),
        name: 'questionnaire',
        component: QuestionnaireDetail,
        meta: { back: 'questionnaires' }
      },

      {
        path: '/news',
        alias: encodeURIComponent('/news'),
        name: 'news',
        component: NewsList,
        meta: { title: 'Новини' }
      },
      {
        path: '/news/:slug',
        alias: encodeURIComponent('/news/:slug'),
        name: 'article',
        component: Article,
        meta: { hero: true, back: 'news' }
      },
      {
        path: '/login',
        name: 'login',
        alias: encodeURIComponent('/login'),
        component: Login,
        meta: { title: 'Вход' }
      },
      {
        path: '/registrations',
        name: 'registration',
        alias: encodeURIComponent('/registrations'),
        component: Registration,
        meta: { title: 'Регистрация' }
      },
      {
        path: '/registrations/verify',
        alias: encodeURIComponent('/registrations/verify'),
        component: SuccessfulRegistration,
        meta: {
          title: 'Регистрация',
          confirmed: false
        }
      },
      {
        path: '/registrations/успех',
        alias: encodeURIComponent('/registrations/успех'),
        component: SuccessfulRegistration,
        meta: {
          title: 'Регистрация',
          confirmed: true
        }
      },
      {
        path: '/forgotten-password',
        alias: encodeURIComponent('/forgotten-password'),
        component: ForgottenPassword,
        meta: { title: 'Забравена парола' },
        name: 'forgot-pass'
      },
      {
        path: '/forgotten-password/verify',
        alias: encodeURIComponent('/forgotten-password/verify'),
        component: ForgottenPassword,
        meta: {
          title: 'Забравена парола',
          sent: true
        }
      },
      {
        path: '/forgotten-password/потребител/:id/token/:token',
        alias: encodeURIComponent('/forgotten-password/потребител/:id/token/:token'),
        component: UpdatePassword,
        meta: { title: 'Забравена парола' },
      },
      {
        path: '/login/token/:token/:redirect?',
        alias: encodeURIComponent('/login/user/:email/token/:token/:redirect?'),
        component: TokenLogin
      },
      {
        path: '/profile',
        name: 'profile',
        alias: encodeURIComponent('/profile'),
        component: Profile,
        meta: {
          title: 'Профил',
          requiresAuth: true
        }
      },
      {
        path: '/about',
        alias: encodeURIComponent('/about'),
        name: 'about',
        component: Page,
        meta: { title: 'За нас', hero: true },
      },
      {
        path: '/404',
        name: '404',
        component: NotFound,
        meta: { title: 'Несъществуваща страница' },
      },
      {
        path: '*',
        component: NotFound
      }
    ]
  })

  return router
}
